export default "__VITE_ASSET__BEpHw$dz__"